var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useReducer, useContext } from "react";
import OpenDrillDownView from "../../common/OpenDrillDownView";
import { WmProgressIndicator, WmProgressMonitor, WmProgressSlice, } from "@watermarkinsights/ripple-react";
import "../../common/Insights.scss";
import { sendRequest } from "../../../common/http";
import { AppContext } from "../../../contexts/AppContext";
import translate from "../../../i18n/translate";
import { useIntl } from "react-intl";
import ApiError from "src/features/common/elements/ApiError";
var popover = function (amount, total) {
    return "".concat(amount, "/").concat(total);
};
var defaultHierarchy = {
    level: 0,
    name: "",
    showStats: false,
    status: "",
    type: "",
    uuid: "",
    children: [],
};
var defaultAction = {
    type: "",
    data: {
        totalOrgs: 0,
        organizationMissionIncomplete: 0,
        organizationMissionComplete: 0,
        learningOutcomes: 0,
        learningOutcomesIncomplete: 0,
        otherOutcomes: 0,
        otherOutcomesIncomplete: 0,
        iloMappings: 0,
        iloMappingsIncomplete: 0,
    },
    hierarchy: defaultHierarchy,
    segment: "",
    apiError: false,
};
var reducer = function (state, action) {
    switch (action.type) {
        case "setMissionOutcome":
            return __assign(__assign({}, state), { totalOrgs: action.data.totalOrgs, organizationMissionIncomplete: action.data.organizationMissionIncomplete, organizationMissionComplete: action.data.organizationMissionComplete, learningOutcomes: action.data.learningOutcomes, learningOutcomesIncomplete: action.data.learningOutcomesIncomplete, otherOutcomes: action.data.otherOutcomes, otherOutcomesIncomplete: action.data.otherOutcomesIncomplete, iloMappings: action.data.iloMappings, iloMappingsIncomplete: action.data.iloMappingsIncomplete });
        case "openDrilldown":
            return __assign(__assign({}, state), { isDrilldownOpen: true, drilldownType: action.segment });
        case "closeDrilldown":
            return __assign(__assign({}, state), { isDrilldownOpen: false, showTable: false, hierarchy: defaultHierarchy });
        case "setHierarchy":
            return __assign(__assign({}, state), { hierarchy: action.hierarchy, showTable: true });
        case "setApiError":
            return __assign(__assign({}, state), { apiError: action.apiError });
        default:
            return state;
    }
};
export default function OrganizationProgressCard(_a) {
    var onTabLoad = _a.onTabLoad, onComponentLoad = _a.onComponentLoad;
    var leads = useContext(AppContext).leads;
    var initialState = {
        drilldownType: "organization",
        drilldownStatus: "any",
        isDrilldownOpen: false,
        hierarchy: defaultHierarchy,
        showTable: false,
        totalOrgs: 0,
        organizationMissionIncomplete: 0,
        organizationMissionComplete: 0,
        learningOutcomes: 0,
        learningOutcomesIncomplete: 0,
        otherOutcomes: 0,
        otherOutcomesIncomplete: 0,
        iloMappings: 0,
        iloMappingsIncomplete: 0,
        apiError: false,
    };
    var _b = useReducer(reducer, initialState), state = _b[0], dispatch = _b[1];
    useEffect(function () {
        var applyResult = function (result) {
            dispatch(__assign(__assign({}, defaultAction), { type: "setMissionOutcome", data: result }));
            onTabLoad("organizations");
            onComponentLoad("organizations");
        };
        var onError = function () {
            dispatch(__assign(__assign({}, defaultAction), { type: "setApiError", apiError: true }));
            onTabLoad("organizations");
            onComponentLoad("organizations");
        };
        sendRequest({ uri: "/mission_outcome/organizations", camelize: true }, applyResult, onError);
    }, []);
    var getDrilldownHierarchy = function (segment) {
        openDrilldown(segment);
        var applyResult = function (result) {
            dispatch(__assign(__assign({}, defaultAction), { type: "setHierarchy", hierarchy: result }));
        };
        sendRequest({ uri: "/hierarchy?segment=".concat(segment), camelize: true }, applyResult);
    };
    var openDrilldownView = function (segment) {
        getDrilldownHierarchy(segment);
    };
    var openDrilldown = function (segment) {
        dispatch(__assign(__assign({}, defaultAction), { type: "openDrilldown", segment: segment }));
    };
    var closeDrilldown = function () {
        dispatch(__assign(__assign({}, defaultAction), { type: "closeDrilldown" }));
    };
    var added = useIntl().formatMessage({
        id: "app.drilldown.added",
    });
    var notAdded = useIntl().formatMessage({
        id: "app.drilldown.notAdded",
    });
    var created = useIntl().formatMessage({
        id: "app.drilldown.created",
    });
    var notCreated = useIntl().formatMessage({
        id: "app.drilldown.notCreated",
    });
    var mapped = useIntl().formatMessage({
        id: "app.drilldown.mapped",
    });
    var notMapped = useIntl().formatMessage({
        id: "app.drilldown.notMapped",
    });
    var POPOVER_BUTTON_TEXT = useIntl().formatMessage({
        id: "app.orgProgressCard.progressDrilldown",
    });
    var DD_SUB_HEADER = useIntl().formatMessage({
        id: "app.orgProgressCard.missionOutcome",
    });
    var totalText = useIntl().formatMessage({ id: "app.orgProgressCard.orgTotal" }, { totalOrgs: state.totalOrgs });
    var organizationsWithoutILO = useIntl().formatMessage({
        id: "app.orgProgressCard.organizationsWithoutILO",
    });
    var organizationsWithILO = useIntl().formatMessage({
        id: "app.orgProgressCard.organizationsWithILO",
    });
    var organizationsWithoutSO = useIntl().formatMessage({
        id: "app.orgProgressCard.organizationsWithoutSO",
    });
    var organizationsWithSO = useIntl().formatMessage({
        id: "app.orgProgressCard.organizationsWithSO",
    });
    var orgWithoutLO = useIntl().formatMessage({
        id: "app.orgProgressCard.orgWithoutLO",
    });
    var orgWithLO = useIntl().formatMessage({
        id: "app.orgProgressCard.orgWithLO",
    });
    var ILOMapped = useIntl().formatMessage({
        id: "app.orgProgressCard.ILOMapped",
    });
    var successOutcomes = useIntl().formatMessage({
        id: "app.orgProgressCard.successOutcomes",
    });
    var learningOutcomes = useIntl().formatMessage({
        id: "app.orgProgressCard.learningOutcomes",
    });
    var orgWithoutMission = useIntl().formatMessage({
        id: "app.orgProgressCard.orgWithoutMission",
    });
    var orgWithMission = useIntl().formatMessage({
        id: "app.orgProgressCard.orgWithMission",
    });
    var missionStatement = useIntl().formatMessage({
        id: "app.orgProgressCard.missionStatement",
    });
    var orgChart = function () {
        return (_jsxs(WmProgressMonitor, { id: "organization-progress", "bar-labels-width": "5rem", children: [_jsxs(WmProgressIndicator, { label: missionStatement, onWmProgressIndicatorButtonTriggered: function () {
                        return openDrilldownView("organization_mission");
                    }, children: [_jsx(WmProgressSlice, { legend: added, amount: state.organizationMissionComplete.toString(), popoverTitle: popover(state.organizationMissionComplete, state.totalOrgs), popoverText: orgWithMission, popoverButtonText: POPOVER_BUTTON_TEXT }), _jsx(WmProgressSlice, { legend: notAdded, amount: state.organizationMissionIncomplete.toString(), popoverTitle: popover(state.organizationMissionIncomplete, state.totalOrgs), popoverText: orgWithoutMission, popoverButtonText: POPOVER_BUTTON_TEXT })] }), _jsxs(WmProgressIndicator, { label: learningOutcomes, onWmProgressIndicatorButtonTriggered: function () {
                        return openDrilldownView("organization_learning_outcome");
                    }, children: [_jsx(WmProgressSlice, { legend: created, amount: state.learningOutcomes.toString(), popoverTitle: popover(state.learningOutcomes, state.totalOrgs), popoverText: orgWithLO, popoverButtonText: POPOVER_BUTTON_TEXT }), _jsx(WmProgressSlice, { legend: notCreated, amount: state.learningOutcomesIncomplete.toString(), popoverTitle: popover(state.learningOutcomesIncomplete, state.totalOrgs), popoverText: orgWithoutLO, popoverButtonText: POPOVER_BUTTON_TEXT })] }), _jsxs(WmProgressIndicator, { label: successOutcomes, onWmProgressIndicatorButtonTriggered: function () {
                        return openDrilldownView("organization_success_outcome");
                    }, children: [_jsx(WmProgressSlice, { legend: created, amount: state.otherOutcomes.toString(), popoverTitle: popover(state.otherOutcomes, state.totalOrgs), popoverText: organizationsWithSO, popoverButtonText: POPOVER_BUTTON_TEXT }), _jsx(WmProgressSlice, { legend: notCreated, amount: state.otherOutcomesIncomplete.toString(), popoverTitle: popover(state.otherOutcomesIncomplete, state.totalOrgs), popoverText: organizationsWithoutSO, popoverButtonText: POPOVER_BUTTON_TEXT })] }), _jsxs(WmProgressIndicator, { label: ILOMapped, onWmProgressIndicatorButtonTriggered: function () {
                        return openDrilldownView("organization_ilo_mapping");
                    }, children: [_jsx(WmProgressSlice, { legend: mapped, amount: state.iloMappings.toString(), popoverTitle: popover(state.iloMappings, state.totalOrgs), popoverText: organizationsWithILO, popoverButtonText: POPOVER_BUTTON_TEXT }), _jsx(WmProgressSlice, { legend: notMapped, popoverTitle: popover(state.iloMappingsIncomplete, state.totalOrgs), popoverText: organizationsWithoutILO, amount: state.iloMappingsIncomplete.toString(), popoverButtonText: POPOVER_BUTTON_TEXT })] })] }));
    };
    return (_jsxs(React.Fragment, { children: [state.apiError ? (_jsx(ApiError, { containerClasses: "api-error" })) : (_jsxs("div", { children: [_jsx("h4", { className: "title", children: translate("app.orgProgressCard.orgProgress") }), _jsx("p", { className: "org totals", children: translate("app.orgProgressCard.orgTotal", {
                            totalOrgs: state.totalOrgs,
                        }) }), _jsx("div", { id: "org-charts", children: orgChart() })] })), _jsx(OpenDrillDownView, { setIsDrilldownOpen: closeDrilldown, drilldownType: state.drilldownType, drilldownStatus: state.drilldownStatus, subHeader: DD_SUB_HEADER, total: totalText, showTable: state.showTable, completeHierarchy: state.hierarchy, leads: leads, isVisible: state.isDrilldownOpen, open: state.isDrilldownOpen, id: "org-progress-drill-down-view" })] }));
}
